module.exports = {
    TRANSACTIONS_MAP: {
        fnol: ['claims', 'fnol'],
        policychange: ['policychange', 'endorsement'],
        quote: ['quoteandbind', 'quote'],
        renewal: ['renewal', 'policyrenewal'],
    },
    LOBS_MAP: {
        bop: ['bop', 'BusinessOwners', 'BusinessOwnersLine', 'BOPLine'],
        ca: ['ca', 'CommercialAuto', 'BusinessAuto', 'BusinessAutoLine'],
        cp: ['cp', 'CommercialProperty', 'CommercialPropertyLine', 'CPLine', 'TWCB_Structure', 'TWCP_Property', 'TWCR_Builders',
            'TWCC_Condo', 'TWCH_Habitational'],
        cpkg: ['cpkg', 'CommercialPackageLine', 'CommercialPackage'],
        gl: ['gl', 'GeneralLiability', 'GeneralLiabilityLine', 'GLLine'],
        ho: [
            'pr',
            'Homeowners', 'homeowners', 'HomeownersLine_HOE', 'HOPHomeowners', 'HOPLine', 'HOLine', 'CommercialProperty', 
        'ResidentialProperty', 'ManufacturedProperty', 'Tenant', 'Condominium', 'Dwelling_Fire', 'TWRD_Dwelling', 'TWRC_Condo', 
        // US13808 add commercial policy types
        'TWRM_Manufactured', 'TWRP_Tenant'
        ],
        im: ['im', 'InlandMarine', 'InlandMarineLine', 'IMLine'],
        pa: ['pa', 'PersonalAuto', 'PersonalAutoLine', 'auto_per', 'auto'],
        wc7: [
            'wc7',
            'WC7WorkersComp',
            'WC7Line',
            'WC7WorkersCompLine',
            "Workers' Compensation (v7)",
        ],
        wc: ['wc', 'WorkersComp', 'WorkersCompLine', "Workers' compensation"],
        gtp: ['gtp'],
        slq: ['slq'],
    },
};
